export default __webpack_public_path__ + "1aaf0b7c95379eca0006cdb33e8ee05b.png";